import React from 'react';

export const PremiumInLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5043 1C2.95202 1 2.5043 1.44772 2.5043 2V13.3306L2.50049 13.3367L2.50224 13.3398L2.5043 13.3378V19.5989C2.5043 19.8513 2.50397 20.2119 2.50351 20.5957C2.50218 21.695 3.38789 22.5907 4.48716 22.5965C4.76961 22.5979 5.02916 22.5989 5.22217 22.5989H6.00018C7.10475 22.5989 8.00018 21.7035 8.00018 20.5989V14C8.00018 11.7909 9.79104 10 12.0002 10C14.2093 10 16.0002 11.7909 16.0002 14V20.5989C16.0002 21.7035 16.8956 22.5989 18.0002 22.5989H19.0367C19.2483 22.5989 19.54 22.5989 19.8561 22.5989C20.9607 22.5989 21.8563 21.7033 21.8563 20.5987C21.8563 20.2103 21.8563 19.8473 21.8563 19.5989V12.0227C21.8563 11.0744 21.408 10.182 20.6472 9.6159L13.9712 4.64822C12.9083 3.85727 11.4524 3.85727 10.3894 4.64822L5.7983 8.0645L7.59412 5.19353C7.79303 4.87552 7.89851 4.50799 7.89851 4.13291V2C7.89851 1.44772 7.4508 1 6.89851 1H3.5043Z"
      fill="currentColor"
    />
  </svg>
);
